export const PUBLIC_URL = process.env.PUBLIC_URL || '';
export const API_VERSION_1 = 'v1/';
export const CONTENT_API_URL = process.env.REACT_APP_CONTENT_API;
export default PUBLIC_URL;
